import { Button, Grid, TextField, Typography } from '@mui/material'
import React from 'react'
import SubCard from 'ui-component/cards/SubCard';
import BackdropLoader from './Components/General/Loader';
import SnackBar from './Components/General/SnackBar';
import { UploadUserRoles } from 'API/HrModule';

const AddUserRole = () => {
    const [UserRole, setUserRole] = React.useState({});
    const [error, setError] = React.useState({ open: false, message: '', type: '' });
    const [isLoading, setIsLoading] = React.useState(false);


    const handleAlertOpen = (message, type) => {
        setError({ open: true, message: message, type: type });
    }

    const handleAlertClose = () => {
        setError({ open: false, message: '', type: '' });
    }


    const handleChange = (name,value) => {
        if (name==='display_name'?/^[a-zA-Z_ ]*$/.test(value):/^[a-zA-Z_]*$/.test(value) && value.length <= 20) {
            setUserRole({ ...UserRole, [name]: value });
        }
    }

    const hadleSubmit=()=>{
        if (!UserRole['user_type'] || !UserRole['display_name'] ) {
            handleAlertOpen("Please enter a valid user role and display name", "error");
            return;
        }

        UploadUserRoles(UserRole,setIsLoading,handleAlertOpen,setUserRole)
        
    }

    return (
        <SubCard sx={{ height: '70vh' }}>
            <BackdropLoader open={isLoading}/>
            <SnackBar open={error.open} message={error.message} type={error.type} handleClose={handleAlertClose} />
            <Grid container spacing={2}>
                <Grid item xs={12}>
                     <Typography
                        variant='h3'
                        sx={{ color: "#000", marginBottom: 1 }}
                        fontWeight={600}
                    >User Role</Typography>
                </Grid>
                <Grid item xs={12} md={3}>
                    <Typography
                        variant='h4'
                        sx={{ color: "#20415C", marginBottom: 1 }}
                        fontWeight={600}
                    >User Type</Typography>
                    <TextField
                        id="outlined-basic"
                        // label="AG Code"
                        sx={{
                            '& .MuiOutlinedInput-root': {
                                border: '2px solid #A9A9A980 50%', // change border color
                                borderRadius: '8px',
                            },
                            '& fieldset': {
                                borderColor: '#A9A9A980',
                                borderRadius: '8px'// default border color
                            },
                        }}
                        size='small'
                        fullWidth
                        value={UserRole["user_type"]?UserRole["user_type"]:""}
                        variant="outlined"
                        onChange={(e) => handleChange("user_type",e.target.value)}
                    />
                </Grid>
                <Grid item xs={12} md={3}>
                    <Typography
                        variant='h4'
                        sx={{ color: "#20415C", marginBottom: 1 }}
                        fontWeight={600}
                    >Display Name</Typography>
                    <TextField
                        id="outlined-basic"
                        // label="AG Code"
                        sx={{
                            '& .MuiOutlinedInput-root': {
                                border: '2px solid #A9A9A980 50%', // change border color
                                borderRadius: '8px',
                            },
                            '& fieldset': {
                                borderColor: '#A9A9A980',
                                borderRadius: '8px'// default border color
                            },
                        }}
                        size='small'
                        fullWidth
                        value={UserRole["display_name"]?UserRole["display_name"]:""}
                        variant="outlined"
                        onChange={(e) => handleChange("display_name",e.target.value)}
                    />
                </Grid>
                <Grid container justifyContent="center" alignItems="center" sx={{ marginTop: 2 }}>
                    <Grid item xs={2}>
                        <Button sx={{
                            backgroundColor: "#688B2A",
                            color: "#fff",
                            borderRadius: "10px",
                            '&:hover': {
                                backgroundColor: "#688B3A",
                                color: "#fff",
                                borderRadius: "10px",
                            },
                        }} variant="contained" color="secondary" onClick={() => hadleSubmit()} fullWidth>
                            Submit
                        </Button>
                    </Grid>
                </Grid>
            </Grid>
        </SubCard>
    )
}

export default AddUserRole